// RUNTIME CONFIGURATION, READ FROM `window.env` (SET BY `public/assets/env.js`).
// SAME CONTRACT AS THE ANGULAR APP'S `src/environments/environment*.ts`: THE
// DEV BUILD FALLS BACK TO STAGE AND THE PRODUCTION BUILD TO PROD, SO THE STAGE
// AND DEMO IMAGES (WHICH RUN NO `envsubst`) STILL RESOLVE TO EXACTLY ONE HOST.

type RuntimeEnv = Partial<Record<string, string>>;

declare global {
  interface Window {
    env?: RuntimeEnv;
  }
}

// GUARDED SO LOGIC THAT IMPORTS THIS CAN BE UNIT TESTED OUTSIDE A BROWSER
const runtime: RuntimeEnv = (typeof window !== "undefined" ? window.env : undefined) ?? {};

const FALLBACK_API = import.meta.env.PROD
  ? "https://api.pillars.io/api/v2"
  : "https://stage-api.pillars.io/api/v2";

export const environment = {
  application: runtime["application"] || "PILLARS-HOST-PRM",
  api: runtime["api"] || FALLBACK_API,
  primaryColor: runtime["primary_color"] || "#009aff",
  // FLOOR MAP MACHINE AND SELECTED-MACHINE PULSE COLORS
  egmBaseColor: runtime["egm_base_color"] || "#000000",
  pulseColor: runtime["pulse_color"] || "#d76b11",
  // PER-PROPERTY TOGGLE FOR TASK TIMES ON THE MANAGER DAILY TASKS VIEW: ONLY "false" HIDES THEM
  displayTaskTimes: runtime["display_task_times"] !== "false",
  // ON-PREM DICTATION (HOST-CRM #125): OPT-IN, ONLY AN EXPLICIT "true" OFFERS THE MICROPHONE,
  // BECAUSE A SITE WITHOUT TRANSCRIPTION DEPLOYED MUST NOT SHOW A CONTROL THAT CANNOT WORK
  speechToText: runtime["speech_to_text"] === "true",
} as const;
